export const getAssignedPrograms = (profilePaneData: any): string[] => {
    const profile = profilePaneData?.profile;
    if (!Array.isArray(profile) || profile.length === 0) {
        return [];
    }
    const programs = profile[0]?.external_programs;
    return Array.isArray(programs) ? programs : [];
};

export const hasAssignedProgram = (profilePaneData: any, programCode: string): boolean => {
    const target = String(programCode || "").trim();
    if (!target) {
        return false;
    }

    return getAssignedPrograms(profilePaneData).some(
        (assignedProgram) => String(assignedProgram).trim() === target
    );
};
